import React from "react";
import { RefreshCw } from "lucide-react";

export default function RefreshMeetingsButton({ onRefresh, refreshing }) {
  return (
    <button
      type="button"
      onClick={onRefresh}
      disabled={refreshing}
      aria-label={refreshing ? "Refreshing meetings" : "Refresh meetings"}
      title="Refresh meetings"
      className="inline-flex shrink-0 items-center justify-center rounded-full p-2 text-blue-700 hover:bg-white/60 disabled:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600"
    >
      <RefreshCw aria-hidden="true" className={`h-6 w-6 ${refreshing ? "animate-spin" : ""}`} />
    </button>
  );
}
